
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HTTP_INTERCEPTORS, HttpParams } from '@angular/common/http';
import { LocalStorageKeys } from 'src/app/configs/local-storage-keys-config';


@Injectable()
export class CultureInterceptor implements HttpInterceptor {

  constructor() {  }

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const newReq = req.clone({
      params: (req.params ? req.params : new HttpParams())
                 .set('culture', localStorage.getItem(LocalStorageKeys.lang))
    });
    return next.handle(newReq);
  }
}

export const HttpCultureInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: CultureInterceptor, multi: true },
];